// PDF Generation - Using html2canvas + jspdf for reliable output
import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const generateAuditPDF = async (pdfData) => {
  try {
    const container = document.getElementById('audit-report-print');
    if (!container) {
      throw new Error('Print element not found');
    }

    // Find all page divs
    const pages = container.querySelectorAll('.audit-page');
    if (pages.length === 0) {
      throw new Error('No pages found');
    }

    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = 210;
    const pageHeight = 297;

    for (let i = 0; i < pages.length; i++) {
      const page = pages[i];

      // Capture each page as a separate canvas
      const canvas = await html2canvas(page, {
        scale: 2,
        useCORS: true,
        allowTaint: true,
        backgroundColor: '#ffffff',
        logging: false,
        width: page.scrollWidth,
        height: page.scrollHeight
      });

      const imgData = canvas.toDataURL('image/png');

      if (i > 0) {
        pdf.addPage();
      }

      // Fit to A4 page
      const imgWidth = pageWidth;
      const imgHeight = (canvas.height * imgWidth) / canvas.width;

      pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, Math.min(imgHeight, pageHeight));
    }

    const filename = `AutomationFirst-Report-${pdfData.company.replace(/\s+/g, '-')}-${new Date().toISOString().split('T')[0]}.pdf`;
    pdf.save(filename);
  } catch (error) {
    console.error('Error generating PDF:', error);
    alert('There was an error generating your PDF. Please try again.');
  }
};

// Email functionality
export const generateConsultationEmail = (pdfData) => {
  const subject = encodeURIComponent(pdfData.consultationSubject);

  const body = encodeURIComponent(`
Hello AutomationFirst Team,

I completed the automation audit and would like to schedule a strategy call.

MY DETAILS:
- Name: ${pdfData.contactName}
- Company: ${pdfData.company}
- Email: ${pdfData.email}
- Industry: ${pdfData.industry}

MY RESULTS:
- Automation Score: ${pdfData.automationScore}/100
- Potential Time Savings: ${pdfData.timeSavingsPotential}
- Potential Cost Savings: ${pdfData.costReductionPotential}
- Focus Department: ${pdfData.department}

TOP PRIORITIES: ${pdfData.priorityAreas ? pdfData.priorityAreas.join(', ') : 'See report'}

Please contact me to schedule a call.

Best regards,
${pdfData.contactName}
  `);

  const mailtoLink = `mailto:${pdfData.consultationEmail}?subject=${subject}&body=${body}`;

  // window.open handles mailto more reliably across browsers/devices than location.href
  const mailWindow = window.open(mailtoLink, '_blank');

  // If popup was blocked or no mail client is configured, the window may not open
  // Fall back to location.href, then show a manual option after a short delay
  if (!mailWindow || mailWindow.closed) {
    window.location.href = mailtoLink;
  }

  // If still nothing happened, give the user the email address to copy
  setTimeout(() => {
    // Only prompt if the page is still visible (user hasn't been redirected to a mail client)
    if (document.hasFocus()) {
      const copyEmail = window.confirm(
        `If your email client didn't open, you can email us directly at:\n\n${pdfData.consultationEmail}\n\nCopy email address to clipboard?`
      );
      if (copyEmail) {
        navigator.clipboard.writeText(pdfData.consultationEmail).catch(() => {});
      }
    }
  }, 1500);
};
